/* eslint-disable class-methods-use-this */
const apiUrl = '//connect.facebook.net/en_US/sdk.js';
const appId = '711802478909910';
const version = 'v2.10';

class FacebookApi {
  constructor() {
    this.api = typeof window !== 'undefined' ? window.FB || null : null;
    this.promise = null;
  }

  fetchScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.onload = resolve;
      script.onerror = reject;
      script.src = url;
      script.id = 'facebook-jssdk';
      script.async = 'async';
      document.body.appendChild(script);
    });
  }

  load() {
    if (this.promise) return this.promise;

    this.promise = new Promise((resolve, reject) => {
      this.fetchScript(apiUrl)
        .then(() => {
          this.api = window.FB;
          this.api.init({
            xfbml: true,
            appId,
            version,
          });
          resolve(this.api);
        })
        .catch(reject);
    });

    return this.promise;
  }

  get() {
    return new Promise((resolve, reject) => {
      if (this.api) {
        return resolve(this.api);
      }

      return this.load()
        .then((api) => {
          resolve(api);
        })
        .catch(() => reject);
    });
  }
}

export default new FacebookApi();
